// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburg332DE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3-2",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3-2",
  seo: {
    title: "\"Erasmus+\"- Programm | Dietz GmbH",
    description: "\"Erasmus+\"- Programm",
  },
  type: "post",
  h1: "\"Erasmus+\"- Programm",
  blocks: [
    { kind: "heading", level: 2, text: "„Erasmus+“- Programm" },
    { kind: "paragraph", text: "Mit dem „Erasmus+“-Programm, eines der wichtigsten Projekte der Europäischen Union zur beruflichen Bildung, werden Mobilität und Arbeitserfahrung im Ausland gefördert. Auch unser Auszubildender Florian Knoch absolvierte hier ein dreiwöchiges Betriebspraktika und erhielt dafür das Zertifikat „Europass Mobilität“." }
  ],
};
